import { render, staticRenderFns } from "./MainLogos.vue?vue&type=template&id=72cadd7d&"
import script from "./MainLogos.vue?vue&type=script&lang=ts&"
export * from "./MainLogos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports